<span id="mitsNumberBoxWrapper" [class.warn]="warn">
  <span class="mitsNumberBoxLabel" *ngIf="label && label.trim().length > 0">
    {{label}}
  </span>
  <span class="mitsNumberBoxButton disable-text-select" [ngClass]="{'disabled': disabled}"
    (click)="clickSubtract()">-</span>
  <!-- max wird bewusst NICHT als Attribut gebunden: bei type=number staucht es die intrinsische
       Feldbreite auf die Ziffernanzahl des Maximums. Die Begrenzung passiert in checkSetValue (JS). -->
  <input type="number" [value]="value" (keyup)="changedValue($event)" [min]="minValue"
    [disabled]="disabled">
  <span class="mitsNumberBoxButton disable-text-select" [ngClass]="{'disabled': disabled}" (click)="clickAdd()">+</span>
</span>